export const NAVIGATION_TRIGGER = {
  BOTTOM_NAVBAR: 'bottom_navigation_bar',
  TOP_NAVBAR: 'top_navigation_bar',
  NAV_DRAWER: 'nav_drawer',
  FOOTER: 'footer',
} as const;

export type NavigationTrigger = (typeof NAVIGATION_TRIGGER)[keyof typeof NAVIGATION_TRIGGER];
